export const ENV_PRODUCTION = 'production'

export const CLAIM_PAGE_URL = 'https://claim.qiibeefoundation.org/'

export const CURRENCY_DELIMITER = "'"

export const SUPPORTED_LANGUAGES = ['en']

export const CURRENCIES = {
  DEFAULT: 'ETH',
  QBX: 'QBX',
  VIR: 'VIR',
  PTS: 'Pts.'
}

export const SALE_PRICING = {
  // @TODO: Change this 3 hours before the sale
  DEFAULT_ETH_PRICE: 2328, // ethPrice from API
  PRE_SALE_DEPOSIT: 1321.14, // 1321/ethPrice
  PUBLIC_SALE_DEPOSIT: 100.104, // 100/ethPrice

  PRE_SALE_QBX_VALUE: 31089,
  PUBLIC_SALE_QBX_VALUE: 2000
}

export const TOTAL_AMOUNT_TO_RAISE = 1000

export const APP_WEB3_STATS = {
  loyalty_wallets: '+200k',
  loyalty_transactions: '+2.1m',
  value_transacted: '+$1.2m',
  mini_app: '+1m',
  wallets_connected: '+270k',
  raised: '$3.2m'
}

export const POINTS_PER_USD = 10

export const REWARDS_TIME_THRESHOLD = {
  FIRST: 30,
  SECOND: 60,
  THIRD: 120,
  FOURTH: 121,
  FIFTH: 180
}

export const REWARDS_TIME_BOOSTER = {
  [REWARDS_TIME_THRESHOLD.FIRST]: 10,
  [REWARDS_TIME_THRESHOLD.SECOND]: 6,
  [REWARDS_TIME_THRESHOLD.THIRD]: 3,
  [REWARDS_TIME_THRESHOLD.FOURTH]: 1,
  [REWARDS_TIME_THRESHOLD.FIFTH]: 8
}

export const REWARDS_LOYALTY_BOOSTER = {
  20: 25,
  10: 12,
  3: 6,
  1: 3
}

export const TIME_BASED_BONUS = {
  1: 15000,
  10: 10000,
  50: 8000,
  100: 6000,
  500: 5000,
  1000: 4000,
  5000: 3000,
  10000: 2000,
  20000: 1000,
  last: 15000
}

export const AMOUNT_BASED_BONUS = {
  5: 20_000,
  10: 50_000,
  20: 125_000,
  50: 300_000,
  100: 750_000,
  max: 1_500_000
}

export const REFERRAL_BONUS = {
  3: 3000,
  10: 10000,
  25: 25000,
  50: 50000,
  100: 100000,
  most: 250000
}

export const INDIVIDUAL_LEADERBOARD_BONUS = {
  1: 100_000,
  2: 50_000,
  3: 25_000,
  '4_10': 10_000,
  '11_100': 5000,
  '101_500': 2500,
  '501_2000': 1000
}

export const COMMUNITY_LEADERBOARD_BONUS = {
  1: 50_000,
  2: 30_000,
  3: 15_000,
  4: 10_000,
  5: 7_500,
  6: 5_000,
  7: 4_000,
  8: 3_000,
  9: 2_000,
  10: 1000
}

export const VIP_CLUB_ACCOUNT_URL = 'https://vip.qiibeefoundation.org/account'

export const ALERT_DISAPPEAR_TIME = 10000 // 10 seconds
export const INFO_ALERT_DISAPPEAR_TIME = 60000 // 60 seconds

export const ANNOUNCE_WINNERS_TIME = 48 // hours

export const REFERRAL_EARNING = 10

export const POLL_ACCOUNT_WALLET_INFO_API_TIME = 2 * 60000 // 2 Minutes

// @TODO: Enable sale results manually whenever get the confirmation from Gianluca/Aaron
// @TODO: remove hard coding
export const ENABLE_SALE_RESULTS = true
export const ENABLE_CLAIM = true

export const NOTIFICATION_CLOSING_TIME = 25000 //ms

export const MIN_ETH_TO_REDEEM_POINTS = 0.043
